<cerrix-dialog [name]="name" [attr.data-uiid]="dataUiid">
    <div header-title>
        <span>
            @if (openReason === OpenAddHyperlinkDialogReason.Add) {
                {{ "cerrix-add-hyperlink-dialog.titleAdd" | transloco }}
            } @else if (openReason === OpenAddHyperlinkDialogReason.Edit) {
                {{ "cerrix-add-hyperlink-dialog.titleEdit" | transloco }}
            } @else if (openReason === OpenAddHyperlinkDialogReason.View) {
                {{ "cerrix-add-hyperlink-dialog.titleView" | transloco }}
            }
        </span>
    </div>
    <div class="add-hyperlink-dialog-content" dialog-content>
        <div class="name-and-hyperlinktype">
            <cerrix-input-group
                [name]="'hyperlink-name'"
                appValidationRequired
                [infoText]="'cerrix-add-hyperlink-dialog.nameInfo' | transloco"
                [placeholder]="'cerrix-add-hyperlink-dialog.namePlaceholder' | transloco"
                [value]="editHyperlink?.name ?? ''"
                (valueChange)="editHyperlink.name = $event"
            >
                {{ "cerrix-add-hyperlink-dialog.nameLabel" | transloco }}
            </cerrix-input-group>
            <app-cerrix-select-group
                name="asset-hyperlinktype"
                [options]="hyperlinkTypeOptions"
                [infoText]="'cerrix-add-hyperlink-dialog.hyperlinkTypeInfo' | transloco"
                [placeholder]="'cerrix-add-hyperlink-dialog.hyperlinkTypePlaceholder' | transloco"
                [selectedValue]="editHyperlink?.hyperlinkType"
                (selectionChange)="onHyperlinkTypeChange($event)"
            >
                {{ "cerrix-add-hyperlink-dialog.hyperlinkTypeLabel" | transloco }}
            </app-cerrix-select-group>
        </div>
        <app-cerrix-hyperlink-url-input-group
            [name]="'hyperlink-url'"
            appValidationRequired
            [value]="editHyperlink?.hyperlinkUrl ?? ''"
            (valueChange)="onHyperlinkUrlChange($event)"
            [infoText]="'cerrix-add-hyperlink-dialog.hyperlinkUrlInfo' | transloco"
            [placeholder]="'cerrix-add-hyperlink-dialog.hyperlinkUrlPlaceholder' | transloco"
        >
            {{ "cerrix-add-hyperlink-dialog.hyperlinkUrlLabel" | transloco }}
        </app-cerrix-hyperlink-url-input-group>
        <cerrix-textarea-group
            [name]="'hyperlink-description'"
            [textareaDialogTitle]="
                'cerrix-add-hyperlink-dialog.hyperlinkDescriptionLabel' | transloco
            "
            [placeholder]="
                'cerrix-add-hyperlink-dialog.hyperlinkDescriptionPlaceholder' | transloco
            "
            [rows]="5"
            [value]="editHyperlink?.description ?? ''"
            (valueChange)="onHyperlinkDescriptionChange($event)"
        >
            {{ "cerrix-add-hyperlink-dialog.hyperlinkDescriptionLabel" | transloco }}
        </cerrix-textarea-group>
    </div>
    <div class="add-hyperlink-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            (click)="cancelDialog.emit(hyperlink)"
            [attr.data-uiid]="dataUiid + '--cancel'"
            >{{ "cerrix-add-hyperlink-dialog.cancel" | transloco }}</cerrix-button
        >
        @if (openReason !== OpenAddHyperlinkDialogReason.View) {
            <cerrix-button
                buttonSize="big"
                primaryColor="green"
                (click)="saveHyperlink()"
                [attr.data-uiid]="dataUiid + '--confirm'"
            >
                @if (openReason === OpenAddHyperlinkDialogReason.Add) {
                    {{ "cerrix-add-hyperlink-dialog.confirmAddHyperlink" | transloco }}
                } @else if (openReason === OpenAddHyperlinkDialogReason.Edit) {
                    {{ "cerrix-add-hyperlink-dialog.confirmEditHyperlink" | transloco }}
                }
            </cerrix-button>
        }
    </div>
</cerrix-dialog>
